import React, { useState } from 'react'

import { Row, Col, Form, FormGroup, Label, Input, Button, Card, CardBody } from "reactstrap"

import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import { loginSuccess } from "../../store/actions"
import toastr from 'toastr'
import ApiService from '../../data/services/ApiService'
import { applyAuthSession, getServerMessage, seleccionarEmpresaActiva } from '../../helpers/empresaUsuarios'

const Login = (props) => {
    const [user, setUser] = useState('')
    const [password, setPassword] = useState('')
    const [empresaSelection, setEmpresaSelection] = useState(null)
    const [loadingSelection, setLoadingSelection] = useState(false)

    const _handleSubmit = async (e) => {
        e.preventDefault()

        if (!_validateNull()) {
            toastr.error('No olvides ingresar tu usuario y password')

            return false
        }

        setEmpresaSelection(null)

        let from = null
        if (props.location.state) {
            const fromLocation = props.location.state.from
            from = fromLocation.pathname + (fromLocation.search || '')
        }

        try {
            const response = await ApiService.login({
                usuario: user,
                password
            })

            if (!response.data?.success) {
                toastr.error(response.data?.message || 'Utilizaste un usuario o password incorrecto', `Espera`)
                return false
            }

            if (response.data?.requiresEmpresaSelection) {
                setEmpresaSelection({
                    empresas: response.data.empresas || [],
                    from
                })

                return false
            }

            applyAuthSession(response.data, props.loginSuccess)
            props.history.push(from || '/')
        } catch (error) {
            toastr.error(getServerMessage(error, 'Utilizaste un usuario o password incorrecto'), `Espera`)
        }
    }

    const _validateNull = () => {
        if (user === '') { return false }
        if (password === '') { return false }

        return true
    }

    const _selectEmpresa = async (empresaId) => {
        const selectedEmpresa = empresaSelection?.empresas?.find(empresa => `${empresa._id}` === `${empresaId}`)
        if (!selectedEmpresa?.selectionToken) {
            return
        }

        setLoadingSelection(true)

        try {
            const response = await seleccionarEmpresaActiva({
                empresaId,
                selectionToken: selectedEmpresa.selectionToken,
                onLoginSuccess: props.loginSuccess
            })

            if (!response.data?.success) {
                toastr.error(response.data?.message || 'No pude iniciar sesión en esta empresa.')
                setLoadingSelection(false)
                return
            }

            props.history.push(empresaSelection.from || '/')
        } catch (error) {
            toastr.error(getServerMessage(error, 'No pude iniciar sesión en esta empresa.'))
            setLoadingSelection(false)
        }
    }

    return(
        <React.Fragment>
            <div className="login">
                <div className="wrapper grid-layout">
                    <Form id="login" type="POST" onSubmit={ _handleSubmit }>
                        <div className="logo">
                            <img alt="Timbrát" src="./assets/images/logo.svg" />
                        </div>
                        <div className="form">
                            <h1>Bienvenido.</h1>
                            <Row>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label htmlFor="name">
                                            Usuario
                                        </Label>
                                        <Input
                                            data-testid="login-user"
                                            type="text"
                                            className="form-control"
                                            value={user}
                                            onChange={event => setUser(event.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label htmlFor="name">
                                            Password
                                        </Label>
                                        <Input
                                            data-testid="login-password"
                                            type="password"
                                            className="form-control"
                                            value={password}
                                            onChange={event => setPassword(event.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row className='form-actions'>
                                <Col sm={12}>
                                    <Button
                                        data-testid="login-submit"
                                        type="submit"
                                        color="primary"
                                        className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                                    >
                                        Iniciar Sesión
                                    </Button>
                                </Col>

                                <Link to="/recuperar-password" onClick={() => {
                                    window.analytics.track('Ir a Recuperar Contraseña')
                                }}>¿Olvidaste tu contraseña?</Link>.
                            </Row>

                            {empresaSelection && empresaSelection.empresas?.length > 0 && (
                                <Row className="mt-4">
                                    <Col sm={12}>
                                        <Card>
                                            <CardBody>
                                                <h2>Selecciona tu empresa</h2>
                                                <p>Tu usuario tiene acceso a varias empresas. Elige cuál quieres administrar.</p>
                                                {empresaSelection.empresas.map((empresa) => (
                                                    <Button
                                                        data-testid="company-option"
                                                        key={empresa._id}
                                                        color="light"
                                                        block
                                                        disabled={loadingSelection}
                                                        onClick={() => _selectEmpresa(empresa._id)}
                                                        style={{ marginBottom: '10px', textAlign: 'left' }}
                                                    >
                                                        <strong>{empresa.nombre}</strong><br />
                                                        <span>{empresa.rfc}</span>
                                                    </Button>
                                                ))}
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            <Row>
                                <Col sm={12} className="login-signup">
                                    <h2>¿Aún no tienes cuenta?</h2>

                                    <a href="https://timbrat.com.mx/registro/" onClick={() => {
                                        window.analytics.track('Ir a Registro')
                                    }}>Crea tu cuenta hoy mismo</a>.
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={12} className="login-copyright">
                                    <p>Copyright © {new Date().getFullYear()}. Todos los Derechos Reservados.</p>
                                    <p>Hecho con amor por <a target="_blank" rel="noopener noreferrer" href="https://juvasoft.com/?utm_source=timbrat&utm_medium=login">Juvasoft</a></p>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default withRouter(
    connect(null, { loginSuccess })(Login)
)
